<div class="edit-account-root">
  <div class="edit-account-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{
          siteVerification.accountKyc?.surname +
          " " +
          siteVerification.accountKyc?.firstName
          }}
        </div>
        <div class="application-number">
          {{ siteVerification.accountKyc?.applicationNumber }}
        </div>
        <div class="edit-accounts-body row">
          <div class="col-12">
            <div class="row">
              <div [ngClass]="{
                  'col-4': siteVerification.accountCreationStatus,
                  'col-12': !siteVerification.accountCreationStatus
                }" *ngIf="!siteVerification.accountKyc?.accountNumber">
                <div class="entry-status new-entry">
                  {{ "COMMON.FILTER_BY_OPTIONS.NEW" | translate }}
                </div>
              </div>
              <div *ngIf="siteVerification.accountKyc?.accountNumber" [ngClass]="{
                  'col-4': siteVerification.accountCreationStatus,
                  'col-12': !siteVerification.accountCreationStatus
                }">
                <div class="entry-status existing-entry">
                  {{ "COMMON.FILTER_BY_OPTIONS.EXISTING" | translate }}
                </div>
              </div>

              <div *ngIf="siteVerification.permiseType" [ngClass]="{
                  'col-8 header-second-column':
                    siteVerification.accountCreationStatus,
                  'col-12': !siteVerification.accountCreationStatus
                }">
                <div class="account-status approval-status new-entry">
                  {{ siteVerification.permiseType }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="account-status" [ngClass]="{
                    'unvalidated-building':
                      siteVerification.status.toString() === 'New',
                    'assigned-building':
                      siteVerification.status.toString() === 'Assigned',
                    'submitted-building':
                      siteVerification.status.toString() === 'Submitted',
                    'approved-building':
                      siteVerification.status.toString() === 'Approved',
                    'rejected-building':
                      siteVerification.status.toString() === 'Rejected',
                    'suspended-building':
                      siteVerification.status.toString() === 'Suspended'
                  }">
                  {{ siteVerification.status.toString() }}
                </div>
              </div>
              <div class="col-8 header-second-column" *ngIf="
                  siteVerification.accountCreationStatus?.toString() ===
                    'Approved' && !siteVerification.accountKyc?.hasCustomer
                ">
                <div class="entry-status approval-status new-entry">
                  {{ "COMMON.ACCOUNT_CREATION" | translate }}
                  {{ "COMMON.ASSET_STATUS.APPROVED" | translate | lowercase }}
                </div>
              </div>
              <div class="col-8 header-second-column" *ngIf="
                  siteVerification.accountCreationStatus?.toString() ===
                  'Pending'
                ">
                <div class="entry-status approval-status submitted-building">
                  {{ "COMMON.ACCOUNT_CREATION" | translate }}
                  {{ "COMMON.ASSET_STATUS.PENDING" | translate | lowercase }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="user-address">
        <div>{{ siteVerification.accountKyc?.email | hasValue }}</div>
        <div>
          +{{ siteVerification.accountKyc?.dialCode | hasValue }}
          {{ siteVerification.accountKyc?.phoneNumber | hasValue }}
        </div>
        <div>
          No.
          {{ siteVerification.accountKyc?.employerAddress?.houseNo | hasValue }}
          {{ siteVerification.accountKyc?.employerAddress?.street | hasValue }}
        </div>
      </div>
    </div>

    <div class="action-buttons" *ngIf="!onlyView">
      <button class="btn btn-header"
        *ngIf="permissionsService.isSiteVerificationSiteVerificationAllowed && !svEditEnabled && !editEnabled"
        (click)="enterSvEdit()">
        {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}
      </button>
      <div class="recall-div" *ngIf="
        (permissionsService.isSiteVerificationRecallAssignedAllowed || permissionsService.isSiteVerificationRecallValidatedAllowed) &&
        (siteVerification.status.toString() === 'Assigned' ||
        siteVerification.status.toString() === 'Approved' ||
        siteVerification.status.toString() === 'Rejected' ||
        siteVerification.status.toString() === 'Suspended')
      ">
        <button class="btn btn-header recall-button" (click)="showRecallMenu = !showRecallMenu">
          <span class="recall-span">{{'COMMON.RECALL' | translate}}</span>
        </button>
        <div *ngIf="showRecallMenu" class="recall-options">
          <div class="recall-type" [ngClass]="[
              siteVerification.status.toString() === 'Assigned'
                ? 'recall-type-enabled'
                : 'recall-type-disabled'
            ]" (click)="
              siteVerification.status.toString() === 'Assigned'
                ? recallSiteVerification()
                : null
            ">
            <span>{{'COMMON.ASSIGNED_TASK' | translate}}</span>
          </div>
          <div class="recall-type" [ngClass]="[
              siteVerification.status.toString() === 'Approved' ||
              siteVerification.status.toString() === 'Rejected' ||
              siteVerification.status.toString() === 'Suspended'
                ? 'recall-type-enabled'
                : 'recall-type-disabled'
            ]" (click)="
              siteVerification.status.toString() === 'Approved' ||
              siteVerification.status.toString() === 'Rejected' ||
              siteVerification.status.toString() === 'Suspended'
                ? recallSiteVerification()
                : null
            ">
            <span>{{'COMMON.VALIDATED_TASK' | translate}}</span>
          </div>
        </div>
      </div>
      <button class="btn btn-header" *ngIf="permissionsService.isSiteVerificationValidationAllowed"
        data-bs-toggle="modal" data-bs-target="#updateStatus" [disabled]="
            siteVerification.status.toString() !== 'Submitted'
          ">
        {{'COMMON.UPDATE_STATUS' | translate}}
      </button>
      <button class="btn btn-header" data-bs-toggle="modal" (click)="getMobileUsers()"
        data-bs-target="#assignToFieldAgent" [disabled]="siteVerification.status.toString() === 'Assigned'" *ngIf="
          permissionsService.isSiteVerificationSiteVerificationAllowed &&
          (siteVerification.status.toString() === 'New' ||
          siteVerification.status.toString() === 'Assigned')
        ">
        {{ "COMMON.ASSIGN_AGENT" | translate }}
      </button>
      <!-- <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#modalApproveCreation" *ngIf="
          siteVerification.status.toString() === 'Approved' &&
          siteVerification.accountCreationStatus?.toString() === 'Pending'
        ">
        Approve account creation
      </button> -->
      <button class="btn btn-header"
        *ngIf="!editEnabled && permissionsService.isSiteVerificationCreateEditAllowed && !svEditEnabled && siteVerification.status.toString() != 'Approved'"
        (click)="edit()">
        {{ "COMMON.EDIT" | translate }}
      </button>
      <button class="btn btn-primary" *ngIf="editEnabled" (click)="save()">
        {{ "COMMON.SAVE" | translate }}
      </button>
      <button class="btn btn-primary" *ngIf="svEditEnabled" (click)="saveSvEdit()">
        {{ "COMMON.SAVE" | translate }}
      </button>
      <button class="btn btn-header" *ngIf="svEditEnabled" (click)="cancelSvEdit()">
        {{ "COMMON.CANCEL" | translate }}
      </button>
    </div>
  </div>
  <div class="edit-accounts-body row">
    <div class="col-13 col-md-4">
      <div class="row">
        <div class="card container col-11">
          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.CUSTOMER_NAME" | translate }}
            </div>
            <div *ngIf="!editEnabled" class="col-8">
              {{
              (siteVerification.accountKyc?.surname ?? "") +
              " " +
              siteVerification.accountKyc?.firstName | hasValue
              }}
            </div>
            <ng-container *ngIf="editEnabled">
              <input placeholder="First name" class="col-4 info-edit" type="text"
                [(ngModel)]="siteVerification.accountKyc.firstName" />
              <input placeholder="Surname" class="col-4 info-edit" type="text"
                [(ngModel)]="siteVerification.accountKyc.surname" />
            </ng-container>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.CUSTOMER_ADDRESS" | translate }}
            </div>
            <div *ngIf="!editEnabled" class="col-8">
              {{ "COMMON.NO." | translate }}
              {{ siteVerification.accountKyc?.addressOfLandlord?.houseNo | hasValue }}
              {{ siteVerification.accountKyc?.addressOfLandlord?.street | hasValue }},
              {{ siteVerification.accountKyc?.addressOfLandlord?.landmark | hasValue }}
            </div>
            <input placeholder="No." *ngIf="editEnabled" class="info-edit col-2"
              [(ngModel)]="siteVerification.accountKyc.employerAddress.houseNo" />
            <input placeholder="Street Name" *ngIf="editEnabled" class="col-6 info-edit address-edit-street"
              [(ngModel)]="siteVerification.accountKyc.employerAddress.street" />
          </div>
          <div class="row" *ngIf="
              siteVerification.accountNumber ||
              siteVerification.accountKyc?.accountNumber
            ">
            <div class="col-4">
              {{ "COMMON.CUSTOMER.ACCOUNT_NUMBER" | translate | titlecase }}
            </div>
            <div class="col-8">
              {{
              siteVerification.accountKyc?.accountNumber ??
              siteVerification.accountNumber | hasValue
              }}
              <span *ngIf="
                  siteVerification.accountCreationStatus?.toString() ===
                  'Pending'
                ">
                <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="30" height="30" rx="20" fill="#FFFFFF" fill-opacity="0.1">
                    <title>
                      {{ "COMMON.AWAITING_ACCOUNT_APPROVAL" | translate }}
                    </title>
                  </rect>
                  <path
                    d="M20 24V20M20 16H20.01M30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20Z"
                    stroke="#fc0303" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.METER_NO" | translate }}
            </div>

            <div class="col-8">
              {{ siteVerification.accountKyc.meterNumber | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.BU.SINGLE" | translate }}
            </div>
            <div *ngIf="!svEditEnabled && !editEnabled" class="col-8">
              <ng-container>
                {{ siteVerification.area.regionName | hasValue }}
              </ng-container>
            </div>
            <div *ngIf="svEditEnabled || editEnabled" class="col-8">
              <select *ngIf="!authService.hasCimDataIntegration" class="form-control sv-select" [(ngModel)]="svRegionId"
                (ngModelChange)="onRegionSelected($event)">
                <option *ngFor="let r of regions" [ngValue]="r.key">{{ r.value }}</option>
              </select>
              <select *ngIf="authService.hasCimDataIntegration" class="form-control sv-select"
                [(ngModel)]="svGeographicalRegionId" (ngModelChange)="onGeoRegionSelected($event)">
                <option *ngFor="let g of geoRegions" [ngValue]="g.id">{{ g.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.UT.SINGLE" | translate }}
            </div>
            <div *ngIf="!svEditEnabled && !editEnabled" class="col-8">
              <ng-container>
                {{ siteVerification.area.name | hasValue }}
              </ng-container>
         
            </div>
            <div *ngIf="svEditEnabled || editEnabled" class="col-8">
              <select *ngIf="!authService.hasCimDataIntegration" class="form-control sv-select" [(ngModel)]="svAreaId"
                (ngModelChange)="onAreaSelected($event)">
                <option *ngFor="let a of areas" [ngValue]="a.key">{{ a.value }}</option>
              </select>
              <select *ngIf="authService.hasCimDataIntegration" class="form-control sv-select"
                [(ngModel)]="siteVerification.subgeographicalRegionId"
                (ngModelChange)="onSubGeoRegionSelected($event)">
                <option *ngFor="let s of selectableSubGeoRegions" [ngValue]="s.id">{{ s.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</div>
            <div class="col-7">{{ siteVerification?.dt?.feeder?.name | hasValue }}</div>
          </div>
          <div class="row">
            <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate}}</div>
            <div class="col-7">
              {{ siteVerification?.dt?.feeder?.number | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'COMMON.DT_NAME' | translate}}</div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification?.dt?.name | hasValue }}
            </div>
            <div *ngIf="svEditEnabled && !authService.hasCimDataIntegration" class="col-8 sv-dropdown-wrapper">
              <div class="sv-select sv-tariff-trigger" (click)="openCardDtDropdown()">
                {{ siteVerification.dt?.name }}
              </div>
              <div class="sv-dropdown-list" *ngIf="svCardDtDropdownOpen">
                <div class="sv-tariff-search-wrap">
                  <input type="text" class="form-control sv-tariff-search" [(ngModel)]="svCardDtFilter"
                    (ngModelChange)="onCardDtFilterChange($event)" autocomplete="off" placeholder="Search..." />
                </div>
                <div class="sv-dropdown-item" *ngFor="let d of svCardDtResults" (click)="selectCardDt(d)">{{ d.name }}
                </div>
              </div>
            </div>
            <div *ngIf="svEditEnabled && authService.hasCimDataIntegration" class="col-8 sv-dropdown-wrapper">
              <div class="sv-select sv-tariff-trigger" (click)="openCardSubstationDropdown()">
                {{ siteVerification.dt?.name }}
              </div>
              <div class="sv-dropdown-list" *ngIf="svCardSubstationDropdownOpen">
                <div class="sv-tariff-search-wrap">
                  <input type="text" class="form-control sv-tariff-search" [(ngModel)]="svCardSubstationFilter"
                    (ngModelChange)="onCardSubstationFilterChange($event)" autocomplete="off" placeholder="Search..." />
                </div>
                <div class="sv-dropdown-item" *ngFor="let s of svCardSubstationResults"
                  (click)="selectCardSubstation(s)">{{ s.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{'COMMON.DT_NUMBER' | translate}}</div>
            <div class="col-7">{{ siteVerification?.dt?.number | hasValue }}</div>
          </div>
        </div>

        <div class="card container col-11">
          <label class="section-label">{{'SERVICE_POINT_DATA.TITLE' | translate}}</label>
          <div class="row">
            <div [ngClass]="{ 'col-4': editEnabled, 'col-6': !editEnabled }">
              {{'SERVICE_POINT_DATA.REQUIRED_SUPPLY_ADDRESS' | translate}}
            </div>
            <div *ngIf="!editEnabled" class="col-6">
              <ng-container *ngIf="siteVerification.accountKyc?.addressOfLandlord?.houseNo">
                {{'COMMON.NO' | translate}}.
              </ng-container>
              {{ siteVerification.accountKyc?.addressOfLandlord?.houseNo | hasValue }}
              {{ siteVerification.accountKyc?.addressOfLandlord?.street | hasValue }},
              {{ siteVerification.accountKyc?.addressOfLandlord?.landmark | hasValue }}
            </div>
            <input [placeholder]="('COMMON.NO' | translate) + '.'" *ngIf="editEnabled" class="info-edit col-2"
              [(ngModel)]="siteVerification.accountKyc.addressOfLandlord.houseNo" />
            <input [placeholder]="'COMMON.STREET_NAME' | translate" *ngIf="editEnabled"
              class="col-6 info-edit address-edit-street"
              [(ngModel)]="siteVerification.accountKyc.addressOfLandlord.street" />
          </div>

          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.REGION' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.area?.regionName | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.AREA' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.area?.name | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.USE_OF_PREMISES' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.useOfPremises | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.PREMISES_TYPE' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.typeOfPremises?.toString() | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.PREMISE_CATEGORY' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.premiseCategory | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.ACTIVITY' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.activity | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.SUBACTIVITY' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.subactivity | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.BUILDING_DEVELOPMENT' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.buildingDevelopmentStage | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.GEOLOCATION' | translate}}</div>

            <div class="locationText col-7">
              <ng-container
                *ngIf="siteVerification.accountKyc?.latitude != null && siteVerification.accountKyc?.longitude != null; else noServicePointGeolocation">
                {{ siteVerification.accountKyc?.latitude }}, {{ siteVerification.accountKyc?.longitude }}
              </ng-container>
              <ng-template #noServicePointGeolocation>
                {{ '' | hasValue }}
              </ng-template>
            </div>
            <div class="location col-1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"
                (click)="openGeolocationMap(siteVerification.accountKyc?.latitude, siteVerification.accountKyc?.longitude)"
                [attr.data-bs-toggle]="siteVerification.accountKyc?.latitude != null && siteVerification.accountKyc?.longitude != null ? 'modal' : null"
                [attr.data-bs-target]="siteVerification.accountKyc?.latitude != null && siteVerification.accountKyc?.longitude != null ? '#showMap' : null">
                <path
                  d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                  fill="#026962" />
              </svg>
            </div>
          </div>
        </div>
        <app-user-activity-section [kycAccountId]="siteVerification.accountKYCId ?? 0"></app-user-activity-section>
      </div>
    </div>
    <div class="col-13 col-md-4">
      <div class="row">
        <div class="card container col-11">
          <label class="section-label">{{
            "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate
            }}</label>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.TYPE_OF_CONNECTION" | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.typeOfConnection | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.typeOfConnection">
                <option *ngFor="let option of svTypeOfConnectionOptions" [ngValue]="option.value">{{ option.value }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{ "COMMON.MBC_DETAILS.FEEDER_NAME" | translate }}</div>
            <div class="col-7">{{ siteVerification.dt?.feeder?.name | hasValue }}</div>
          </div>
          <div class="row">
            <div class="col-5">
              {{ "COMMON.MBC_DETAILS.FEEDER_NUMBER" | translate }}
            </div>
            <div class="col-7">
              {{ siteVerification?.dt?.feeder?.number | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{ "COMMON.DT_NAME" | translate }}</div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.dt?.name | hasValue }}
            </div>
            <div *ngIf="svEditEnabled && !authService.hasCimDataIntegration" class="col-8 sv-dropdown-wrapper">
              <div class="sv-select sv-tariff-trigger" (click)="openSvDtDropdown()">
                {{ siteVerification.dt?.name }}
              </div>
              <div class="sv-dropdown-list" *ngIf="svSvDtDropdownOpen">
                <div class="sv-tariff-search-wrap">
                  <input type="text" class="form-control sv-tariff-search" [(ngModel)]="svSvDtFilter"
                    (ngModelChange)="onSvDtFilterChange($event)" autocomplete="off" placeholder="Search..." />
                </div>
                <div class="sv-dropdown-item" *ngFor="let d of svSvDtResults" (click)="selectSvDt(d)">{{ d.name }}</div>
              </div>
            </div>
            <div *ngIf="svEditEnabled && authService.hasCimDataIntegration" class="col-8 sv-dropdown-wrapper">
              <div class="sv-select sv-tariff-trigger" (click)="openSvSubstationDropdown()">
                {{ siteVerification.dt?.name }}
              </div>
              <div class="sv-dropdown-list" *ngIf="svSvSubstationDropdownOpen">
                <div class="sv-tariff-search-wrap">
                  <input type="text" class="form-control sv-tariff-search" [(ngModel)]="svSvSubstationFilter"
                    (ngModelChange)="onSvSubstationFilterChange($event)" autocomplete="off" placeholder="Search..." />
                </div>
                <div class="sv-dropdown-item" *ngFor="let s of svSvSubstationResults" (click)="selectSvSubstation(s)">
                  {{ s.name }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{'COMMON.DT_NUMBER' | translate}}</div>
            <div class="col-7">{{ siteVerification.dt?.number | hasValue }}</div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ 'COMMON.CONNECTION_TYPE' | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.connectionType | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.connectionType">
                <option *ngFor="let option of svTypeOfConnections" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ 'COMMON.TYPE_OF_CABLE' | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.typeOfCable | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.typeOfCable">
                <option *ngFor="let option of svTypesOfCable" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ 'COMMON.CONNECTION_POSSIBLE' | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.connectionPossible | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.connectionPossible">
                <option *ngFor="let option of svConnectionPossibleoptions" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ 'COMMON.NEED_FOR_POLE' | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.needForPole | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.needForPole">
                <option *ngFor="let option of svNeedForPoleOptions" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.NEIGHBORHOOD" | translate }}
              {{ "COMMON.TARIFF.CLASS" | translate | lowercase }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.neighborhood | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.neighborhood">
                <option *ngFor="let option of svNeighborhoodOptions" [ngValue]="option.value">{{ option.value }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.NUMBER_OF_ROOMS" | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.numberOfRooms | hasValue }}
            </div>
            <input *ngIf="svEditEnabled" type="number" class="info-edit col-8"
              [(ngModel)]="siteVerification.numberOfRooms" />
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.SLT_STATUS.SINGLE" | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.sltStatusValue | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.sltStatusValue">
                <option *ngFor="let option of svSltOptions" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{ "COMMON.TARIFF.SINGLE" | translate }}</div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.tariff | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8 sv-dropdown-wrapper">
              <div class="sv-select sv-tariff-trigger"
                (click)="svTariffDropdownOpen ? svTariffDropdownOpen = false : openTariffDropdown()">
                {{ siteVerification.tariff }}
              </div>
              <div class="sv-dropdown-list" *ngIf="svTariffDropdownOpen">
                <div class="sv-tariff-search-wrap">
                  <input type="text" class="form-control sv-tariff-search" [(ngModel)]="svTariffFilter"
                    (ngModelChange)="onTariffFilterChange($event)" autocomplete="off" placeholder="Search..." />
                </div>
                <div class="sv-dropdown-item" *ngFor="let t of svTariffResults" (click)="selectTariff(t)">{{ t.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.TABLE_HEADERS.METER_TYPE" | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.meterBrand | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.meterBrand">
                <option *ngFor="let option of svMeterTypeOptions" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              {{ "COMMON.MBC_DETAILS.CLIENT_TYPE" | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-8">
              {{ siteVerification.clientType | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-8">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.clientType">
                <option *ngFor="let option of svClientTypeOptions" [ngValue]="option.value">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              {{ "SITE_VERIFICATION.REMARK" | translate }}
            </div>
            <div *ngIf="!svEditEnabled" class="col-7">
              {{ siteVerification.remark | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-7">
              <select class="form-control sv-select" [(ngModel)]="siteVerification.remark"
                (ngModelChange)="onRemarkChange($event)">
                <option *ngFor="let option of svRemarks" [ngValue]="option.key">{{ option.value }}</option>
              </select>
            </div>
          </div>
          <div class="row" *ngIf="siteVerification.remark == 'Reject' || siteVerification.remark == 'Suspend'">
            <div class="col-5">
              {{ "SITE_VERIFICATION.REASON" | translate }}
            </div>
            <div *ngIf="!svEditEnabled && siteVerification.remark == 'Reject'" class="col-7">
              {{ siteVerification.rejectionReason | hasValue }}
            </div>
            <div *ngIf="!svEditEnabled && siteVerification.remark == 'Suspend'" class="col-7">
              {{ siteVerification.suspensionReason | hasValue }}
            </div>
            <div *ngIf="svEditEnabled" class="col-7">
              <input *ngIf="siteVerification.remark == 'Reject'" placeholder="Reason" class="w-100" type="text"
                [(ngModel)]="siteVerification.rejectionReason" />
              <input *ngIf="siteVerification.remark == 'Suspend'" placeholder="Reason" class="w-100" type="text"
                [(ngModel)]="siteVerification.suspensionReason" />
            </div>

          </div>
          <div class="row">
            <div class="col-5">
              {{ "COMMON.MBC_DETAILS.GEO_LOCATION" | translate }}
            </div>
            <div class="locationText col-6">
              {{ siteVerification.latitude }},
              {{ siteVerification.longitude }}
            </div>
            <div class="location col-1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"
                (click)="svEditEnabled ? openSvGeoModal() : openGeolocationMap(siteVerification.latitude, siteVerification.longitude)"
                [attr.data-bs-toggle]="!svEditEnabled && siteVerification.latitude != null && siteVerification.longitude != null ? 'modal' : null"
                [attr.data-bs-target]="!svEditEnabled && siteVerification.latitude != null && siteVerification.longitude != null ? '#showMap' : null">
                <path
                  d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                  fill="#026962" />
              </svg>
            </div>
          </div>
        </div>

        <div class="card container col-11">
          <label class="section-label">{{'CUSTOMER_DATA.TITLE' | translate}}</label>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.ACC_NAME' | translate }}</div>

            <div class="col-7">
              {{ (siteVerification.accountKyc?.surname + ' ' + siteVerification.accountKyc?.firstName) | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{'PERSONAL_DATA.CUSTOMER_PHONE_NO' | translate}}</div>
            <div *ngIf="!editEnabled" class="col-7">
              <p>
                <ng-container *ngIf="siteVerification.accountKyc?.buildingOwnerDialCode">
                  +
                </ng-container>
                {{ siteVerification.accountKyc?.dialCode | hasValue }}
                {{ siteVerification.accountKyc?.phoneNumber | hasValue }}
              </p>
            </div>
            <input [placeholder]="'PERSONAL_DATA.CODE' | translate" *ngIf="editEnabled" class="info-edit col-2"
              [(ngModel)]="siteVerification.accountKyc.dialCode" />
            <input [placeholder]="'PERSONAL_DATA.PHONE_NO' | translate" *ngIf="editEnabled" class="info-edit col-5"
              [(ngModel)]="siteVerification.accountKyc.phoneNumber" />
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.EMAIL' | translate }}</div>
            <div *ngIf="!editEnabled" class="col-7">
              {{ siteVerification.accountKyc?.email }}
            </div>
            <input [placeholder]="'PERSONAL_DATA.CODE' | translate" *ngIf="editEnabled" class="info-edit col-7"
              [(ngModel)]="siteVerification.accountKyc.email" />
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.OWNERSHIP_STATUS' | translate }}</div>

            <div class="col-7">
              {{ siteVerification.accountKyc?.ownershipStatus | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-6">{{ 'CUSTOMER_DATA.BUILDING_OWNER' | translate }}</div>

            <div *ngIf="!editEnabled" class="col-6">
              {{ siteVerification.accountKyc?.buildingOwner | hasValue }}
            </div>
            <input *ngIf="editEnabled && siteVerification.accountKyc?.ownershipStatus !== 'Owner'"
              [placeholder]="'PERSONAL_DATA.BUILDING_OWNER_NAME' | translate" class="info-edit col-6"
              [(ngModel)]="siteVerification.accountKyc.buildingOwner" />
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.CUSTOMER_IDENTIFICATION' | translate }}</div>

            <div class="col-7">
              {{ siteVerification.accountKyc?.identificationOfLandlord | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.PERSONAL_ID_NUM' | translate }}</div>

            <div class="col-7">
              {{ siteVerification.accountKyc?.personalIdNumberOfLandlord | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{ 'CUSTOMER_DATA.DATE_OF_BIRTH' | translate }}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.dateOfBirth | date : "dd/MM/yyyy" }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.NATIONALITY' | translate }}</div>

            <div class="col-7">
              {{ siteVerification.accountKyc?.nationality | hasValue }}
            </div>
          </div>

          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.GENDER' | translate }}</div>

            <div class="col-7">
              {{ siteVerification.accountKyc?.gender | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.NIN' | translate }}</div>

            <div class="col-7">
              {{ siteVerification.accountKyc?.nin | hasValue }}
              <app-nin-verification-popup [nin]="siteVerification.accountKyc?.nin"
                [accountId]="siteVerification.accountKYCId"></app-nin-verification-popup>
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.SERVICE_TYPE' | translate}}</div>

            <div class="col-8">
              {{ siteVerification.accountKyc?.serviceType | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{'SERVICE_POINT_DATA.SUB_SERVICE_TYPE' | translate}}</div>

            <div class="col-8">
              {{ subServieSpaces(siteVerification.accountKyc?.subServiceType) | hasValue }}
            </div>
          </div>
          <div *ngIf="siteVerification.accountKyc.identificationIssueDate" class="row">
            <div class="col-5">Identification Issue Date</div>

            <div class="col-7">
              {{ siteVerification.accountKyc.identificationIssueDate | date : "dd/MM/yyyy" }}
            </div>
          </div>
          <div *ngIf="siteVerification.accountKyc.identificationExpiryDate" class="row">
            <div class="col-5">Identification Expiry Date</div>

            <div class="col-7">
              {{ siteVerification.accountKyc.identificationExpiryDate | date : "dd/MM/yyyy" }}
            </div>
          </div>

          <div class="row">
            <div class="col-5">Customer Type</div>

            <div class="col-7">
              {{ customerType | hasValue }}
            </div>
          </div>

          <div class="row">
            <div class="col-5">Client Type</div>

            <div class="col-7">
              {{ clientType | hasValue }}
            </div>
          </div>
        </div>

        <div class="card container col-11">
          <label class="section-label">{{
            "PERSONAL_DATA.DECLARATION" | translate
            }}</label>
          <div class="row" *ngFor="
              let loadItem of this.siteVerification.accountKyc?.loadRequirements
            ">
            <div class="col-6">
              {{ loadItem.name }}
            </div>

            <div class="col-2">
              {{ loadItem.number }}
            </div>
            <div class="col-4">
              {{ loadItem.wattage }}
            </div>
          </div>
          <div class="row">
            <div class="col-6">Total load</div>

            <div class="col-2">
              ----
            </div>
            <div class="col-4">
              {{ totalLoad }}
            </div>
          </div>
        </div>
        <div class="card container col-11 meter-request-card">
          <div class="meter-request-header">
            <label class="section-label">{{'METER_REQUEST.TITLE' | translate}}</label>
            <span class="count-badge">{{ siteVerification.accountKyc?.relatedAccounts?.length || 0 }}</span>
          </div>
          <div class="meter-request-table">
            <div class="row table-header-row">
              <div class="col-3">{{'METER_REQUEST.SERVICE_ORDER_ID' | translate}}</div>
              <div class="col-3">{{'METER_REQUEST.ACCOUNT_NUMBER' | translate}}</div>
              <div class="col-3">{{'METER_REQUEST.SPN' | translate}}</div>
              <div class="col-3">{{'METER_REQUEST.PHASE_REQUESTED' | translate}}</div>
            </div>
            <div class="row table-data-row" *ngFor="let account of siteVerification.accountKyc?.relatedAccounts">
              <div class="col-3">{{ account.serviceOrderId | hasValue }}</div>
              <div class="col-3">{{ account.accountNumber | hasValue }}</div>
              <div class="col-3">{{ account.spn | hasValue }}</div>
              <div class="col-3">{{ account.phaseRequested | hasValue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="image-container col-13 col-md-4">
      <div class="card container">
        <div>{{ "COMMON.PICTURES.FRONT" | translate }}</div>
        <div class="images-list">
          <div>
            <label *ngIf="getFrontViewImage(0) && svEditEnabled" class="sv-clickable-img">
              <img src="{{ getFrontViewImage(0) }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'Frontview', 0)" />
            </label>
            <img *ngIf="getFrontViewImage(0) && !svEditEnabled" src="{{ getFrontViewImage(0) }}" (click)="showImage(0)"
              data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!getFrontViewImage(0) && svEditEnabled" class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'Frontview', 0)" />
            </label>
            <img *ngIf="!getFrontViewImage(0) && !svEditEnabled" class="no-image" src="{{ placeholderImage }}"
              alt="Placeholder image" />
          </div>

          <div *ngIf="areLocationImagesVisible">
            <label *ngIf="getFrontViewImage(1) && svEditEnabled" class="sv-clickable-img">
              <img src="{{ getFrontViewImage(1) }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'Frontview', 1)" />
            </label>
            <img *ngIf="getFrontViewImage(1) && !svEditEnabled" src="{{ getFrontViewImage(1) }}" (click)="showImage(1)"
              data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!getFrontViewImage(1) && svEditEnabled" class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'Frontview', 1)" />
            </label>
            <img *ngIf="!getFrontViewImage(1) && !svEditEnabled" class="no-image" src="{{ placeholderImage }}"
              alt="Placeholder image" />
          </div>

          <div *ngIf="areLocationImagesVisible">
            <label *ngIf="getFrontViewImage(2) && svEditEnabled" class="sv-clickable-img">
              <img src="{{ getFrontViewImage(2) }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'Frontview', 2)" />
            </label>
            <img *ngIf="getFrontViewImage(2) && !svEditEnabled" src="{{ getFrontViewImage(2) }}" (click)="showImage(2)"
              data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!getFrontViewImage(2) && svEditEnabled" class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'Frontview', 2)" />
            </label>
            <img *ngIf="!getFrontViewImage(2) && !svEditEnabled" class="no-image" src="{{ placeholderImage }}"
              alt="Placeholder image" />
          </div>
        </div>
      </div>
      <div class="card container" *ngIf="areLocationImagesVisible">
        <div>{{ "COMMON.PICTURES.MOUNTED_TAG" | translate }}</div>
        <div>
          <div>
            <label *ngIf="getBuildingMountedImage() && svEditEnabled" class="sv-clickable-img">
              <img src="{{ getBuildingMountedImage() }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'MountedTag')" />
            </label>
            <img *ngIf="getBuildingMountedImage() && !svEditEnabled" src="{{ getBuildingMountedImage() }}"
              (click)="showImage(3)" data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!getBuildingMountedImage() && svEditEnabled" class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'MountedTag')" />
            </label>
            <img *ngIf="!getBuildingMountedImage() && !svEditEnabled" class="no-image" src="{{ placeholderImage }}"
              alt="Placeholder image" />
          </div>
        </div>
      </div>
      <div class="card container"
        *ngIf="siteVerification.accountKyc.clientTypeString == 'Individual' && areLocationImagesVisible">
        <div>{{ "COMMON.PICTURES.CUSTOMER_ID_CARD" | translate }}</div>
        <div class="images-list">
          <div>
            <label *ngIf="siteVerification.accountKyc?.applicantsSignitureUrl && svEditEnabled"
              class="sv-clickable-img">
              <img src="{{ siteVerification.accountKyc?.applicantsSignitureUrl }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input" (change)="onSvImageSelected($event, 'Card')" />
            </label>
            <img *ngIf="siteVerification.accountKyc?.applicantsSignitureUrl && !svEditEnabled"
              src="{{ siteVerification.accountKyc?.applicantsSignitureUrl }}" (click)="showImage(8)"
              data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!siteVerification.accountKyc?.applicantsSignitureUrl && svEditEnabled"
              class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input" (change)="onSvImageSelected($event, 'Card')" />
            </label>
            <img *ngIf="!siteVerification.accountKyc?.applicantsSignitureUrl && !svEditEnabled" class="no-image"
              src="{{ placeholderImage }}" alt="Placeholder image" />
          </div>
        </div>
      </div>

      <div class="card container" *ngIf="areLocationImagesVisible">
        <div>{{ "COMMON.PICTURES.CUT_OUT" | translate }}</div>
        <div>
          <div>
            <label *ngIf="getCutOutImage() && svEditEnabled" class="sv-clickable-img">
              <img src="{{ getCutOutImage() }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'CutOutFuse')" />
            </label>
            <img *ngIf="getCutOutImage() && !svEditEnabled" src="{{ getCutOutImage() }}" (click)="showImage(10)"
              data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!getCutOutImage() && svEditEnabled" class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'CutOutFuse')" />
            </label>
            <img *ngIf="!getCutOutImage() && !svEditEnabled" class="no-image" src="{{ placeholderImage }}"
              alt="Placeholder image" />
          </div>
        </div>
      </div>
      <div class="card container">
        <div>{{ "COMMON.PICTURES.UTILITY_SUPPLY" | translate }}</div>
        <div>
          <div>
            <label *ngIf="getUtilitySupplyImage() && svEditEnabled" class="sv-clickable-img">
              <img src="{{ getUtilitySupplyImage() }}" alt="Item image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'UtilitySupply')" />
            </label>
            <img *ngIf="getUtilitySupplyImage() && !svEditEnabled" src="{{ getUtilitySupplyImage() }}"
              (click)="showImage(11)" data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
            <label *ngIf="!getUtilitySupplyImage() && svEditEnabled" class="sv-clickable-img">
              <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
              <input type="file" accept="image/*" class="sv-file-input"
                (change)="onSvImageSelected($event, 'UtilitySupply')" />
            </label>
            <img *ngIf="!getUtilitySupplyImage() && !svEditEnabled" class="no-image" src="{{ placeholderImage }}"
              alt="Placeholder image" />
          </div>
        </div>
      </div>
      <div class="card container">
        <div>
          <div>
            {{ "COMMON.PICTURES.ELECT_CONTRACTOR_SIGNATURE" | translate }}
          </div>
          <div class="images-list">
            <button class="btn btn-outline-dark"
              (click)="openPdf(siteVerification.accountKyc?.electricalContractorsSignitureUrl ?? '')">View PDF</button>
          </div>
        </div>
      </div>

      <div class="card container">
        <div>{{ "COMMON.PICTURES.APPLICANT_PASSPORT" | translate }}</div>
        <div class="images-list">
          <div>
            <img *ngIf="siteVerification.accountKyc?.passportUrl; else noImage"
              src="{{ siteVerification.accountKyc?.passportUrl }}" (click)="showImage(9)" data-bs-toggle="modal"
              data-bs-target="#modalImage" alt="Item image" />
          </div>
        </div>
      </div>
      <div class="card container" *ngIf="siteVerification.accountKyc?.ownershipStatus == 'Owner'">
        <div>{{'COMMON.PDF.PROOF_OWNERSHIP' | translate}}</div>
        <div class="images-list">
          <div>
            <button class="btn btn-outline-dark"
              (click)="openPdf(siteVerification.accountKyc?.proofOfOwnershipUrl ?? '')">View PDF</button>
          </div>
        </div>
      </div>
      <div class="card container" *ngIf="siteVerification.accountKyc?.ownershipStatus == 'Tenant'">
        <div>{{'COMMON.PDF.LETTER_CONSENT' | translate}}</div>
        <div class="images-list">
          <div>

            <button class="btn btn-outline-dark"
              (click)="openPdf(siteVerification.accountKyc?.letterOfConsentUrl ?? '')">View PDF</button>
          </div>
        </div>
      </div>
      <div class="card container" *ngIf="siteVerification.accountKyc?.ownershipStatus == 'Tenant'">
        <div>{{'COMMON.PDF.AGREEMENT' | translate}}</div>
        <div class="images-list">
          <div>

            <button class="btn btn-outline-dark"
              (click)="openPdf(siteVerification.accountKyc?.tenancyAgreementUrl ?? '')">View PDF</button>
          </div>
        </div>
      </div>
      <div class="card container"
        *ngIf="siteVerification.accountKyc?.clientTypeString != 'Individual' && siteVerification.accountKyc?.clientType != null">
        <div>{{'COMMON.PDF.LETTER_AUTHRIZATION' | translate}}</div>
        <div class="images-list">
          <div>
            <button class="btn btn-outline-dark"
              (click)="openPdf(siteVerification.accountKyc?.letterOfAuthorizationUrl ?? '')">View PDF</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
    (shown.bs.modal)="onModalOpen()">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-image">
        <div class="modal-body modal-body-image">
          <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
            <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage" [thumbImage]="selectedImage"
              [magnification]="3">
            </lib-ngx-image-zoom>
          </div>
          <div class="rotate-div">
            <button class="btn btn-primary left-button" (click)="rotateLeft()">
              &lt;
            </button>
            <button class="btn btn-primary right-button" (click)="rotateRight()">
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true"
    (shown.bs.modal)="onGeolocationMapModalOpen()" (hidden.bs.modal)="onGeolocationMapModalFade()">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-geolocation-map-viewer *ngIf="selectedMapLatitude != null && selectedMapLongitude != null"
            [setMapVisibility]="isGeolocationMapVisible" [longitude]="selectedMapLongitude"
            [latitude]="selectedMapLatitude"></app-geolocation-map-viewer>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true"
    (hidden.bs.modal)="onModalAssignFade()">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ "COMMON.ASSIGN_AGENT" | translate }}</h5>
          <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{ "COMMON.CANCEL" | translate }}
          </button>
        </div>
        <div class="modal-body">
          <div class="form-floating form-item">
            <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
              class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }"
              id="floatingInput" (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
            <label for="floatingInput">{{
              "COMMON.FIELD_AGENT" | translate
              }}</label>

            <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
              <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
                *ngFor="let u of mobileUsers">
                {{ u.fullName }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="assignTask()">
            {{ "COMMON.ASSIGN_TASK" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="updateStatus" tabindex="-1" role="dialog" aria-hidden="true" (hidden.bs.modal)="cancelModal()">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
          <button type="button" class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{ "COMMON.CANCEL" | translate }}
          </button>
        </div>
        <div *ngIf="!showApprove && !showReject && !showSuspend" class="modal-footer updateStatus updateStatus-nowrap">
          <button type="button" class="btn btn-primary approve" (click)="showApproveConfirm($event)">
            {{'COMMON.APPROVE' | translate}}
          </button>
          <button type="button" class="btn btn-danger" (click)="showRejectForm($event)">
            {{'COMMON.REJECT' | translate}}
          </button>
          <button type="button" class="btn btn-suspend" (click)="showSuspendConfirm($event)">
            {{'COMMON.SUSPEND' | translate}}
          </button>
        </div>
        <div *ngIf="showApprove" class="modal-footer updateStatus">
          <div>
            <h3>{{'DATA_QUALITY.APPROVE' | translate}}</h3>
          </div>
          <button type="button" class="btn btn-primary approve" (click)="approve()">
            {{'COMMON.YES' | translate}}
          </button>
          <button type="button" (click)="cancelUpdateStatus($event)" class="btn btn-danger">
            {{'COMMON.NO' | translate}}
          </button>
        </div>
        <div *ngIf="showSuspend" class="modal-footer updateStatus">
          <form id="rejectForm" ngNativeValidate (submit)="submitSuspend()">
            <div style="padding: 10px">
              <textarea required rows="10" cols="70" name="note" [(ngModel)]="suspensionNote"
                class="form-control"></textarea>
            </div>
            <div class="buttons">
              <button type="submit" class="btn btn-primary">
                {{'DATA_QUALITY.SUBMIT_SUSPENSION' | translate}}
              </button>
              <button type="button" class="btn btn-danger" (click)="cancelUpdateStatus($event)">
                {{'COMMON.CANCEL' | translate}}
              </button>
            </div>
          </form>
        </div>
        <div class="modal-body">
          <div *ngIf="showReject">
            <form id="rejectForm" ngNativeValidate (submit)="reject()">
              <div style="padding: 10px">
                <textarea required rows="10" cols="70" name="note" [(ngModel)]="rejectionNote"
                  class="form-control"></textarea>
              </div>
              <div class="buttons">
                <button type="submit" class="btn btn-primary">
                  {{'DATA_QUALITY.SUBMIT_REJECTION' | translate}}
                </button>
                <button type="button" class="btn btn-danger" (click)="cancelUpdateStatus($event)">
                  {{'COMMON.CANCEL' | translate}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="modal fade" id="modalApproveCreation" tabindex="-1" aria-hidden="true"
  (hidden.bs.modal)="onModalApproveFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Approve Account Creation</h5>
      </div>
      <div class="modal-body">
        <div class="form-floating form-item">
          <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
            class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
            (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
          <label for="floatingInput">Field Agent for survey</label>

          <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
            <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
              *ngFor="let u of mobileUsers">
              {{ u.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          You have opted to approve the account creation for this site
          verification, please click the Approve button below to proceed.
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-outline-danger" style="width: 100%" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-success" style="width: 100%" (click)="approveAccountCreation()">
              Approve
            </button>
          </div>
        </div>
      </div>
    </div>
  </div> 
</div> -->

  <div class="geo-location-modal-backdrop" *ngIf="svGeoModalVisible" (click)="closeSvGeoModal()">
    <div class="geo-location-modal geo-location-modal--large" (click)="$event.stopPropagation()">
      <div class="geo-location-modal-header">
        <h4 class="geo-location-modal-title--map">{{ svGeoModalTitle }}</h4>
        <div class="geo-location-modal-header-actions">
          <button *ngIf="svHasSavedGeoLocation && !svIsMapEditMode" type="button" class="geo-location-edit"
            (click)="enterSvMapEditMode()" aria-label="Edit coordinates">
            <svg width="20" height="20" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M13.25 6.25229L15.25 4.25229C16.4926 3.00965 18.5074 3.00965 19.75 4.25229C20.9926 5.49493 20.9926 7.50965 19.75 8.75229L17.75 10.7523M13.25 6.25229L3.33579 16.1665C2.96071 16.5416 2.75 17.0503 2.75 17.5807V21.2523H6.42157C6.95201 21.2523 7.46071 21.0416 7.83579 20.6665L17.75 10.7523M13.25 6.25229L17.75 10.7523"
                stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
          <button type="button" class="geo-location-close" (click)="closeSvGeoModal()">
            <img src="assets/solid.svg" alt="Close" />
          </button>
        </div>
      </div>

      <div class="geo-location-modal-body geo-location-modal-body--map">
        <div class="geo-location-map-placeholder">
          <google-map class="geo-location-map" height="100%" width="100%" [zoom]="svMapZoom" [center]="svMapCenter"
            [options]="svMapOptions" (mapInitialized)="onSvMapInitialized()">
            <map-marker [position]="svMarkerPosition" [options]="svMarkerOptions" (mapDragstart)="onSvMarkerDragStart()"
              (mapDragend)="onSvMarkerDragEnd($event)"></map-marker>
          </google-map>
        </div>
      </div>

      <div class="geo-location-modal-footer geo-location-modal-footer--map"
        *ngIf="!svHasSavedGeoLocation || svIsMapEditMode">
        <div style="display:flex; gap:0.8rem;">
          <button type="button" class="geo-location-action geo-location-action--secondary"
            (click)="cancelSvMapSelection()">
            {{ "COMMON.CANCEL" | translate }}
          </button>
          <button type="button" class="geo-location-action geo-location-action--primary" (click)="saveSvGeoLocation()">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noImage>
    <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
  </ng-template>